import { Dialog, Transition } from "@headlessui/react";
import { Fragment, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { uploadNewDoc } from "../../api/document";

export const NewDocModal = ({ isOpen, onOpen, onClose }) => {
  const fileUploadRef = useRef(null);
  const notesRef = useRef(null);
  const nameRef = useRef(null);
  const user = useSelector(state => state.user);
  const navigate = useNavigate();

  const [uploading, setUploading] = useState(false);

  const uploadNewVersion = () => {
    setUploading(true);
    const file = fileUploadRef.current.files[0];
    const notes = notesRef.current.value;
    const name = nameRef.current.value;

    if (!name || name.length < 3) {
      toast("Please enter a name over 3 characters", { type: "error" });
      setUploading(false);
      return;
    }

    if (!file) {
      toast("Please select a file", { type: "error" });
      setUploading(false);
      return;
    }

    uploadNewDoc({ file, token: user.token, name, notes })
      .then(res => {
        if (res === null) {
          toast("Something went wrong", { type: "error" });
          return;
        }

        setUploading(false);
        toast("Document created!", { type: "success" });
        setTimeout(() => {
          toast("Redirecting", { type: "info" });
          onClose();
          setTimeout(
            () => navigate("/dashboard/document/" + res.document.id),
            500
          );
        }, 1000);
      })
      .catch(e => {
        console.log(e);
        toast("Something went wrong", { type: "error" });
      });
  };

  return (
    <Transition.Root show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-10" onClose={() => {}}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed z-10 inset-0 overflow-y-auto">
          <div className="flex items-end sm:items-center justify-center min-h-full p-4  sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:max-w-lg sm:w-full sm:p-6">
                <div>
                  <div>
                    <Dialog.Title className="text-xl text-gray-900 font-bold">
                      Create a new document
                    </Dialog.Title>

                    <div className="mt-4">
                      <div className="mb-6">
                        <label className="block mb-2 text-sm font-medium text-gray-900">
                          Document name{" "}
                          <span className="text-gray-400">(required)</span>
                        </label>
                        <input
                          ref={nameRef}
                          type="text"
                          className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 transition-all duration-200 ease-in-out"
                          placeholder="Woah cool doc bro >.>"
                          required
                        />
                      </div>

                      <label className="block mb-2 text-sm font-medium text-gray-900">
                        Your Note{" "}
                        <span className="text-gray-400">(optional)</span>
                      </label>
                      <textarea
                        ref={notesRef}
                        rows="4"
                        className="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 mb-6 transition-all duration-200 ease-in-out"
                        placeholder="Leave a comment..."
                      ></textarea>

                      <label className="block">
                        <input
                          ref={fileUploadRef}
                          type="file"
                          className="cursor-pointer block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100"
                        />
                      </label>
                    </div>
                  </div>
                </div>
                <div className="mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">
                  <button
                    type="button"
                    className={`w-full inline-flex justify-center rounded-md border h-10 border-transparent shadow-sm  bg-black-600  text-white hover:bg-black-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-black-500 sm:col-start-2 sm:text-sm btn btn-sm ${
                      uploading && "loading"
                    }`}
                    onClick={uploadNewVersion}
                  >
                    Upload
                  </button>
                  <button
                    type="button"
                    className={`mt-3 w-full inline-flex justify-center rounded-md border  h-10 border-gray-300 shadow-sm  bg-white text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-black-500 sm:mt-0 sm:col-start-1 sm:text-sm btn btn-sm ${
                      uploading && "loading"
                    }`}
                    onClick={onClose}
                  >
                    Cancel
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
};
